module.exports = __webpack_public_path__ + "img/SM.7c35df37.png";